<template>
  <a-modal
    centered
    v-model="visible"
    class="custom-modal"
    :title="title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button v-if="haveFooter" key="submit" type="primary" @click="handleOk">
        {{ btnConfirm ? btnConfirm : defaultConfirmBtn }}
      </a-button>
      
    </template>
    <!-- <div class="cus-modal-body"> -->
    <!-- <slot name="tungdeptrai" :handleOk="handleOk" test="tung dep trai"></slot> -->
    <slot></slot>
    <!-- </div> -->
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      // isShow: false
      defaultCancelBtn: this.$t("popup.commons.label_popup_cancel_button1"),
      defaultConfirmBtn: this.$t(
        "popup.commons.label_popup_title_cancel_approve"
      ),
    };
  },
  // props: ["visible", "title", "btnConfirm", "btnCancel", "haveFooter", "isDisableConfirm"],
  props: {
    title: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    btnCancel: {
      type: String,
      default: null,
    },
    btnConfirm: {
      type: String,
      default: null,
    },
    haveFooter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.isShow;
      },
      set(newData) {
        return newData;
      },
    },
  },
  methods: {
    handleCancel() {
      this.$emit("handleCancel");
    },
    handleOk() {
      // this.$emit('handleCancel')
      this.$emit("handleOk");
    },
  },
};
</script>

<style lang="scss">
.custom-modal {
  .ant-modal-mask,
  .ant-modal-wrap {
    z-index: 1030;
  }
  .ant-modal {
    width: 100% !important;
    max-width: 655px;
  }
  .ant-modal-content {
    border-radius: 10px;
    overflow: hidden;
  }
  .ant-modal-header {
    background-color: #d2d6ff;
    border-bottom-color: #3d4cdc;
    .ant-modal-title {
      color: #3d4cdc;
    }
  }
  .ant-modal-close {
    outline: unset !important;
  }

  .ant-modal-close-x {
    line-height: 48px;
    outline: unset !important;
  }
  .ant-modal-body {
    padding: 20px;
  }
  .ant-modal-footer {
    border-top: unset;
    display: flex;
    padding-bottom: 20px;
    padding-top: 0px;
    justify-content: center;
    & > .ant-btn:first-child {
      margin-right: 10px;
      background-color: #3d4cdc;
      color: #fff;
    }
    // & > .ant-btn:last-child {
    //   background-color: #ececec;
    //   color: #6f6f6f;
    // }
    & > .ant-btn {
      // padding-top: 12px;
      // padding-bottom: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      width: 210px;
      height: 40px;
      font-weight: 700;
      font-size: 14px;
    }
  }
}
</style>
